module.exports = __webpack_public_path__ + "static/media/vi.207949f4.svg";